import React, { useState, MouseEvent, useEffect } from "react";
import styles from './Product.module.css';
import ReactGA from 'react-ga4';
import Image from 'next/image';
import { ScoreExplain } from "./ScoreExplain";
import { ScoreExplainModal } from "./ScoreExplainModal";
import { ProductType, ProductDetailInfo, ShoppingItem } from "../../../types/Product";
import { SpecsContainer } from "../productSpecs/SpecsContainer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { ProductImages } from "./ProductImages";
const Product: React.FC<ProductType & {
  onExpandClick: () => void;
  onMouseEnter?: () => void;
  expanded: boolean;
  productBasicInfoList: any[];
  productDetailInfoList: any[];
}> = ({
  id,
  index,
  title,
  price,
  average_price_for_used,
  rating,
  brand,
  buyer,
  sub_category,
  amazon_link,
  reviewer_number,
  score,
  analysis_result,
  Image_Links,
  onExpandClick,
  onMouseEnter,
  expanded,
  productBasicInfoList,
  productDetailInfoList,
  pros,
  cons,
  onClick
}) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalPosition, setModalPosition] = useState({
    top: 0,
    right: 0
  });
  const [activeTab, setActiveTab] = useState('Pros & Cons');
  const showModal = (event: React.MouseEvent<SVGTextElement, MouseEvent>) => {
    event.stopPropagation();
    setModalPosition({
      top: event.clientY,
      right: event.clientX
    });
    setModalVisible(true);
    ReactGA.event({
      category: 'Button Click',
      action: 'showModal'
    });
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const handleGoToStore = (index: number) => {
    window.open(amazon_link ? amazon_link : getAmazonLink(index), '_blank');
    ReactGA.event({
      category: 'Button Click',
      action: 'goToStore'
    });
  };
  const goodBar = {
    height: "16px",
    width: analysis_result['positive_percentage'] * 1.5 + 8,
    backgroundColor: "#4CAF50",
    borderRadius: "3px"
  };
  const neuBar = {
    height: "16px",
    width: analysis_result['neutral_percentage'] * 1.5 + 8,
    backgroundColor: "#FFCD39",
    borderRadius: "3px"
  };
  const badBar = {
    height: "16px",
    width: analysis_result['critical_percentage'] * 1.5 + 8,
    backgroundColor: "#F6695E",
    borderRadius: "3px"
  };
  title = productBasicInfoList[index]?.product_name;
  delete productDetailInfoList[index]?.id;
  const productDetail = productDetailInfoList[index];

  //This part will construct 3 columns to display on the product detail section.
  const productDetailEntries = Object.entries(productDetail) as [keyof ProductDetailInfo, string][];
  const productDetailColumn1 = productDetailEntries.slice(0, 3);
  const productDetailColumn2 = productDetailEntries.slice(3, 6);
  const productDetailColumn3 = productDetailEntries.slice(6, 9);
  function getAmazonLink(index: number) {
    let recommendationLink = '';
    const shoppingList: ShoppingItem[] = productBasicInfoList[index]?.recommendation_links;
    if (shoppingList && shoppingList.length > 0) {
      const shoppingItem = shoppingList.find(item => {
        return item?.seller && (item.seller.includes("Amazon") || item.seller.includes("amazon"));
      });
      if (shoppingItem) {
        recommendationLink = shoppingItem.link;
        console.log("recommendationLink", recommendationLink);
      }
    }
    return recommendationLink;
  }
  return <div className={styles.product} onMouseEnter={onMouseEnter} data-sentry-component="Product" data-sentry-source-file="Product.tsx">
            <div id={styles.upperContainer}>
                <div id={styles.productInfoContainer}>
                    <ProductImages id={id} index={index} title={title} picture={Image_Links[0]?.link} price={price} average_price_for_used={average_price_for_used} rating={rating} brand={brand} buyer={buyer} sub_category={sub_category} amazon_link={amazon_link} reviewer_number={reviewer_number} score={score} analysis_result={analysis_result} Image_Links={Image_Links} onExpandClick={onExpandClick} onMouseEnter={onMouseEnter} expanded={expanded} pros={pros} cons={cons} onClick={onClick} productBasicInfoList={productBasicInfoList} data-sentry-element="ProductImages" data-sentry-source-file="Product.tsx" />

                    <div id={styles.productInfo}>
                        <div id={styles.upperInfo}>
                            <p className={styles.productBrand}>{brand}</p>
                            <p className={styles.productTitle}>{title}</p>
                        </div>

                        <div id={styles.downInfo}>
                            <p className={styles.productInfoFont}>Estimated Price for new: <span style={{
                fontWeight: 'bold'
              }}>${price}</span></p>
                            <p className={styles.productInfoFont}>Estimated Price for used: <span style={{
                fontWeight: 'bold'
              }}>${average_price_for_used}</span></p>
                            <p className={styles.productInfoFont}>Category: {sub_category}</p>
                            <p className={styles.productInfoFont}>{reviewer_number} Reviews</p>
                        </div>
                    </div>
                </div>

                <div id={styles.analysisPart} onClick={() => onExpandClick()}>
                    <p className={styles.review_summary}>Review Summary</p>
                    <div className={styles.barArea}>
                        <div className={styles.ratingBar}>
                            <div className="flex gap-1">
                                <div id='barGood' style={goodBar}></div>
                                <p className={styles.ratingPercentage}>{Math.round(analysis_result['positive_percentage'])}%</p>
                            </div>
                            <p className={styles.ratingText}>Good</p>
                        </div>
                        <div className={styles.ratingBar}>
                            <div className="flex gap-1">
                                <div id='barNeu' style={neuBar}></div>
                                <p className={styles.ratingPercentage}>{Math.round(analysis_result['neutral_percentage'])}%</p>
                            </div>
                            <p className={styles.ratingText}>Neutral</p>
                        </div>
                        <div className={styles.ratingBar}>
                            <div className="flex gap-1">
                                <div id='barBad' style={badBar}></div>
                                <p className={styles.ratingPercentage}>{Math.round(analysis_result['critical_percentage'])}%</p>
                            </div>
                            <p className={styles.ratingText}>Bad</p>
                        </div>
                        <div className={styles.resourcesGroup}>
                            <p className={styles.resourcesText}>Powered by AI. Resources:</p>
                            <div className={styles.resourcesImgGroup}>
                                <Image className={styles.recommendedLogo} src="/resourcesIcon/amazon.png" alt="amazon" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="Product.tsx" />
                                <Image className={styles.recommendedLogo} src="/resourcesIcon/youtube.png" alt="youtube" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="Product.tsx" />
                                <Image className={styles.recommendedLogo} src="/resourcesIcon/reddit.png" alt="reddit" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="Product.tsx" />
                                <Image className={styles.recommendedLogo} src="/resourcesIcon/ebay.png" alt="ebay" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="Product.tsx" />
                            </div>
                        </div>
                    </div>
                </div>

                <div id={styles.scoreGeneralContainer}>
                    <div id={styles.scoreContainer}>
                        <svg viewBox="0 0 36 36" className={styles.circleProgressBar} data-sentry-element="svg" data-sentry-source-file="Product.tsx">
                            <path className={styles.circle_bg} d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831" data-sentry-element="path" data-sentry-source-file="Product.tsx" />
                            <path className={styles.circle} strokeDasharray={`${score}, 100`} d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831" data-sentry-element="path" data-sentry-source-file="Product.tsx" />
                        </svg>

                        <div id={styles.scoreNumberContainer}>
                            <p id={styles.scoreNumber}>{(score / 20).toFixed(1)}</p>
                            <p id={styles.scoreText}>points</p>
                        </div>
                    </div>

                    <ScoreExplain data-sentry-element="ScoreExplain" data-sentry-source-file="Product.tsx" />
                </div>
            </div>

            <div id={styles.midContainer}>
                <div id={styles.lowerContainer}>
                    <div className="flex flex-row gap-2">
                        <button className={activeTab === 'Pros & Cons' ? styles.activeTab : styles.unactiveTab} onClick={() => setActiveTab('Pros & Cons')}>
                            Pros & Cons
                        </button>
                        <button className={activeTab === 'Specs' ? styles.activeTab : styles.unactiveTab} onClick={() => setActiveTab('Specs')}>
                            Specs
                        </button>
						
                    </div>

                    {activeTab === 'Specs' && <div id={styles.productDetailContainerFooter}>
                            <div id={styles.productDetailContainer}>
                                <div className={styles.productDetailColumn}>
                                    {productDetailColumn1.map(([key, value]) => <div className={styles.productDetailRow} key={key}>
                                            <Image src={`/productDetailIcon/${key}.svg`} alt="detail" width={24} height={24} />
                                            <p className={styles.productDetailText}>{key}: {value}</p>
                                        </div>)}
                                </div>

                                <div className={styles.productDetailColumn}>
                                    {productDetailColumn2.map(([key, value]) => <div className={styles.productDetailRow} key={key}>
                                            <Image src={`/productDetailIcon/${key}.svg`} alt="detail" width={24} height={24} />
                                            <p className={styles.productDetailText}>{key}: {value}</p>
                                        </div>)}
                                </div>

                                <div className={styles.productDetailColumn}>
                                    {productDetailColumn3.map(([key, value]) => <div className={styles.productDetailRow} key={key}>
                                            <Image src={`/productDetailIcon/${key}.svg`} alt="detail" width={24} height={24} />
                                            <p className={styles.productDetailText}>{key}: {value}</p>
                                        </div>)}
                                </div>
                            </div>
                            <div className={styles.resourcesGroupFooter}>
                                <p className={styles.resourcesText}>Powered by AI. Resources:</p>
                                <div className={styles.resourcesImgGroup}>
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/amazon.png" alt="amazon" width={20} height={20} />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/youtube.png" alt="youtube" width={20} height={20} />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/reddit.png" alt="reddit" width={20} height={20} />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/ebay.png" alt="ebay" width={20} height={20} />
                                </div>
                            </div>
                        </div>}

                    {activeTab === 'Pros & Cons' && <div id={styles.prosConsContainerFooter}>
                            <div id={styles.prosConsContainer}>
                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-row items-center">
                                        <FontAwesomeIcon icon={faThumbsUp} className="text-green-500 mr-2 text-sm font-bold w-[15px] h-[15px]" />
                                        <h3 className={styles.prosConsTitle}>Pros</h3>
                                    </div>
                                    <p className="text-[14px] leading-5">
                                        {pros}
                                    </p>
                                </div>
                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-row items-center">
                                        <FontAwesomeIcon icon={faThumbsDown} className="text-red-500 mr-2 text-sm font-bold w-[15px] h-[15px]" />
                                        <h3 className={styles.prosConsTitle}>Cons</h3>
                                    </div>
                                    <p className="text-[14px] leading-5">
                                        {cons}
                                    </p>
                                </div>
                            </div>
                            <div className={styles.resourcesGroupFooter}>
                                <p className={styles.resourcesText}>Powered by AI. Resources:</p>
                                <div className={styles.resourcesImgGroup}>
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/amazon.png" alt="amazon" width={20} height={20} />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/youtube.png" alt="youtube" width={20} height={20} />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/reddit.png" alt="reddit" width={20} height={20} />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/ebay.png" alt="ebay" width={20} height={20} />
                                </div>
                            </div>
                        </div>}
                </div>
                <button id={styles.goToStoreButton} onClick={() => handleGoToStore(index)}>Go to Amazon</button>
            </div>	


			{!expanded && <div id={styles.downArrow} onClick={() => onExpandClick()}>
					<p>EXPAND</p>
					<Image className={styles.arrowIcon} src="/assets/double-arrow-down-rounded.svg" alt="img" width={20} height={20}></Image>
				</div>}


			<ScoreExplainModal data-sentry-element="ScoreExplainModal" data-sentry-source-file="Product.tsx" />

		</div>;
};
export default Product;